import SpeciesSelectMultiple from "./SpeciesSelectMultiple";
import SpeciesSelectSingle from "./SpeciesSelectSingle";
import { SpeciesSelectElementProps } from "./types";

export default function SpeciesSelectElement(props: SpeciesSelectElementProps) {
    return props.multiple ? <SpeciesSelectMultiple {...props} /> : <SpeciesSelectSingle {...props} />;
}
